module.exports = __webpack_public_path__ + "img/image-17.3a4640ba.png";